import { Button } from "antd";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="py-6 px-4 md:px-6 lg:px-8 border-b">
      <div className="container mx-auto flex items-center justify-between">
        <Link to="/" className="text-4xl font-bold text-primary">
          Aura Connect
        </Link>
        {/* <nav className="hidden md:flex space-x-4">
          <Link
            to="#features"
            className="text-lg hover:text-primary transition-colors"
          >
            Features
          </Link>
          <Link
            to="#testimonials"
            className="text-lg hover:text-primary transition-colors"
          >
            Testimonials
          </Link>
        </nav> */}
      </div>
    </header>
  );
};

export default Header;
